"use client";
import useTranslate from "@app/_hooks/useTranslate";
import { Heading } from "@components/ui/Heading/Heading";
import { LoginButton } from "@features/auth/components/LoginButton";
import useAuth from "@features/auth/hooks/useAuth";
import { useRouter } from "next/navigation";

export default function CheckoutHeading() {
  const t = useTranslate();
  const router = useRouter();
  const { user } = useAuth();

  return (
    <section>
      <div className="flex items-center justify-between p-4 lg:py-8">
        <Heading as="h1" size={5}>
          {t("yourCart")}
        </Heading>
        {!user && (
          <p className="hidden text-sm uppercase md:block">
            {t("alreadyHaveAnAccount")}{" "}
            <LoginButton
              className="inline-block uppercase underline"
              redirectOnSuccess={false}
              onSuccess={() => router.refresh()}
            >
              {t("login")}
            </LoginButton>
          </p>
        )}
      </div>
      <div className="child:text-sm child:text-color-base hidden w-full pr-3 pb-2 pl-[140px] uppercase lg:grid lg:grid-cols-[3fr_1fr_1fr_1fr]">
        <p className="col-start-2 text-end">{t("quantity")}</p>
        <p className="col-start-3 text-end">{t("pricePerItem")}</p>
        <p className="col-start-4 text-end">{`${t("total")} (${t("vatIncluded")})`}</p>
      </div>
    </section>
  );
}
